import React, { useRef, useState } from 'react';

// material-ui
import {
  AppBar,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  IconButton,
  LinearProgress,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Slide,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

// project imports

import {
  useAPSExtractFile,
  useAPSExtractFileCCT,
  useAPSExtractFormData,
  useAPSExtractIssues,
  useAPSExtractRFIs,
  useAPSExtractSubittals,
  useApsGetFormList,
  useApsGetHubs,
  useApsGetProjects
} from '../../../hooks/useAps';
import useConnectionStore from '../../../store/useConnectors';
import useExtractStore from '../../../store/useExtract';
import ApsFolderContentDialog from '../../../components/autodesk/folderContentLoads';
import { useSnackbar } from 'notistack';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AutodeskModuleScreen({ open, onClose, onConfirm }) {
  const payloadForm = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const { connectionOwnerName, activeConnectionId } = useConnectionStore((s) => s);

  const { data: dataHubs, isFetching: isLoadingHubs, isError: isErrorHubs } = useApsGetHubs();
  const [projectId, setprojectId] = useState(0);

  const { mutate: extractFormData, isPending: isExtractingFormData, isSuccess: isSuccessFormData } = useAPSExtractFormData();

  const [openFolderDialog, setopenFolderDialog] = useState(false);
  const [openProject, setopenProject] = useState(false)

  const [idFormData, setidFormData] = useState('');
  const { refetch: fetchFormList, isFetching: isLoadingFormsList, isError: isErrorFormList } = useApsGetFormList(projectId);

  const [hubId, sethubId] = useState('');
  const [hubName, sethubName] = useState("")
  const { data: dataProjects, isFetching: isLoadingProjects, isError: isErrorProjects } = useApsGetProjects(hubId);

  const { setHubName, hubname, setOpenProject, setDataFormDetail, formDetail } = useExtractStore();

  const handleViewProjects = (data) => {
    // setviewProjects(true);
    setopenProject(true);
    sethubId(data.id);
    sethubName(data.attributes?.name);
  };

  const [extractType, setextractType] = useState('');
  const [dataProject, setdataProject] = useState(null);

  // const handleSelectProject = (data) => {
  //   setdataProject(data);
  // };

  const handleSelectProject = (data) => {
    
    // setAnchorEl(null);
    // const data = dataProject;
    const idProject = data?.relationships['issues'].data.id;
    setprojectId(idProject);
    const payload = {
      project_id: idProject.split('b.')[0],
      project_name: data.attributes.name,
      hub_name: hubName,
      hub_id: hubId,
      connection_id: activeConnectionId,
      connection_user_name: connectionOwnerName
    };
    console.log(payload);

    setopenFolderDialog(true);
    payloadForm.current = payload;

  };

  const [openFormModal, setopenFormModal] = useState(false);

  const handleOpenFormModal = () => {
    setopenFormModal(true);
  };

  const handleCloseFormModal = (param) => {
    setopenFormModal(false);
    if (param === 'close') return false;
    if (!idFormData) return false;
    const payload = {
      ...payloadForm.current,
      templateId: idFormData
    };
    console.log(payload);
    extractFormData(payload, {
      onSuccess: () => {
        closeDialog('success', payloadForm.current.type);
      }
    });
  };

  const handleCloseFolderContent = (data) => {
    setopenFolderDialog(false);
  };

  const handleConfirmFolderContent = (data) => {
    console.log("close file management",data)
    setopenFolderDialog(false);
    const val ={
      provider: "autodesk",
      connection_id: activeConnectionId,
      folder_id: data.id,
      project_id: `b.${projectId}`
    }
    onConfirm(val)
  };

  const handleBackHub = () => {
    setHubName('');
    setCloseProject(false);
  };

  const isPageLoading = isLoadingHubs || isLoadingProjects;
  

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        slots={{
          transition: Transition
        }}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            {openProject && (
              <IconButton edge="start" color="inherit" onClick={handleBackHub} aria-label="close">
                <ArrowBackIcon />
              </IconButton>
            )}
            <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h5" component="div">
              {openProject ? `Hub ${hubname}` : 'Choose Hub'}
            </Typography>
            <Button autoFocus color="inherit" onClick={onClose}>
              CLOSE
            </Button>
          </Toolbar>
        </AppBar>

        <Box mt={5} px={1}>
          {isPageLoading && (
            <Box
              sx={{
                width: '100%'
              }}
            >
              <LinearProgress />
            </Box>
          )}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: '35%' }}>
                    <strong>{openProject ? 'Project Name' : 'Hub Name'}</strong>
                  </TableCell>
                  <TableCell sx={{ width: '65%' }}>
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {!openProject &&
                  dataHubs?.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell sx={{ width: '40%' }}>{row?.attributes?.name}</TableCell>

                      <TableCell sx={{ width: '60%' }}>
                        <Box>
                          <Button
                            sx={{ fontWeight: 'bold' }}
                            onClick={() => handleViewProjects(row)}
                            variant="outlined"
                            startIcon={<VisibilityOutlinedIcon />}
                          >
                            View Projects
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                {openProject &&
                  dataProjects?.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row?.attributes?.name}</TableCell>

                      <TableCell>
                        <Stack direction={'row'} spacing={1}>
                          <Button
                            sx={{ fontWeight: 'bold' }}
                            // endIcon={<KeyboardArrowDownIcon />}
                            onClick={(e) => handleSelectProject(row)}
                            variant="outlined"
                          >
                            Select
                          </Button>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Dialog open={openFormModal} onClose={() => handleCloseFormModal('close')}>
            <DialogTitle>Select a Form</DialogTitle>
            <DialogContent>
              <DialogContentText>Available Form</DialogContentText>
              <Box sx={{ width: '25vw', mt: 3 }}>
                {/* <form onSubmit={handleSubmit} id="subscription-form"> */}
                <TextField
                  fullWidth
                  id="outlined-select-currency"
                  select
                  label="Select Type"
                  defaultValue="all"
                  value={idFormData}
                  onChange={(e) => setidFormData(e.target.value)}
                >
                  {projectId &&
                    formDetail?.data?.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option?.name}
                      </MenuItem>
                    ))}
                </TextField>
                {/* </form> */}
                <Button
                  onClick={() => handleCloseFormModal('submit')}
                  sx={{ mt: 3, fontWeight: 'bold' }}
                  fullWidth
                  variant="contained"
                  form="subscription-form"
                >
                  SUBMIT
                </Button>
              </Box>
            </DialogContent>
          </Dialog>
        </Box>
      </Dialog>
      {openFolderDialog && (
        <ApsFolderContentDialog
          open={openFolderDialog}
          data={payloadForm.current}
          onClose={handleCloseFolderContent}
          onConfirm={(param) => handleConfirmFolderContent(param)}
        />
      )}
    </>
  );
}
